import { fireEvent } from "./events";

const Errors = {
    ServiceUnavailable: 503,
    InternalError: -1,
    BadBrandingSignature: -2,
    InsertCard: -3,
    WrongCard: -4,
    RedPin: -5,
    NoCardReader: -6,
    BiscCertNotFound: -7,
    WrongCA: -8,
    RedPinX: -9,
    WrongTime: -10,
    ServiceBusy: -11,
    WrongRecipient: -12,
    CommErr: -13,
    NoEidCard: -14,
    UnknownEidCert: -15,
    SwitchedCard: -16,
    InactiveCard: -17,
    UserCancelled: -18,
    NoPinpad: -19,
    BlockedPin: -20,
    WrongUser: -21,
    TimeoutError: -22,
    PINpadErr: -23,
    SCardErr: -24,
    FailedGetCert: -25,
    ConfigError: -26,
    NoIsabelReader: -27,
    OrangePin: -28
};

export function handleServiceException (error) {
    if (error.message == Errors.InternalError) {
        // non-IE browsers return this code
        // when the card certificate is invalid
        fireEvent('invalidCard');
    } else if (error.message == Errors.UserCancelled) {
        // non-IE browsers return this code
        // when the user cancels the action
        fireEvent('cardNotInserted');
    }
}

export function handleError (error) {
    fireEvent(error);
    // log error in console
    switch (error) {
        case 'wrongBrowser':
            console.warn('The browser is not supported');
            break;

        case 'notInstalled':
            console.warn('Isabel Security Components are not installed');
            break;

        case 'refusedVersion':
            console.warn('The version of the Isabel Security Components is not supported');
            break;

        case 'noCardReader':
            console.warn('The Isabel Card Reader is not available');
            break;

        case 'cardNotInserted':
            console.warn('No card found in the Isabel Card Reader');
            break;

        case 'noCertificate':
            console.warn('The Isabel Card certificate is not installed');
            break;

        case 'invalidCard':
            console.warn('The card inserted in the Isabel Card Reader is not valid');
            break;
    }
}